export function redirectToApp(appInfo, code) {
  let location = appInfo.redirect_uri;
  location += location.indexOf('?') > -1 ? `&code=${code}` : `?code=${code}`;
  if (appInfo.state) location += `&state=${encodeURIComponent(appInfo.state)}`;
  if (appInfo.client_id) location += `&client_id=${appInfo.client_id}`;
  if (appInfo.nonce) location += `&nonce=${encodeURIComponent(appInfo.nonce)}`;
  window.location.href = location;
}

export function redirectToAppWithError(appInfo, error, description) {
  let location = appInfo.redirect_uri;
  location += location.indexOf('?') > -1 ? '&error=' : '?error=';
  location += error || 'unknown_error';
  if (description) location += `&error_description=${encodeURIComponent(description)}`;
  if (appInfo.client_id) location += `&client_id=${appInfo.client_id}`;
  window.location.href = location;
}

export function filterAccounts(accounts, productCode) {
  let key = '';
  switch (productCode) {
    case 'projects':
      key = 'projectsEnabled';
      break;
    case 'desk':
      key = 'deskEnabled';
      break;
    case 'chat':
      key = 'chatEnabled';
      break;
    default:
      return accounts;
  }
  return accounts.filter((acc) => acc.installation[key]);
}



// WEBPACK FOOTER //
// ./src/utils/appLoginHelper.js